import { variants } from '@app/shared/vue/components/sf-banner/constants'

const messageType = {
  ALERT: 'alert',
  ERROR: 'error',
  NOTICE: 'notice',
  SUCCESS: 'success',
} as const

export const messageTypeToVariant = {
  [messageType.ALERT]: variants.warning,
  [messageType.ERROR]: variants.danger,
  [messageType.NOTICE]: variants.info,
  [messageType.SUCCESS]: variants.success,
} as const

export type MessageTypeToVariantType =
  typeof messageTypeToVariant[keyof typeof messageTypeToVariant]

export const ON_LOAD_BANNERS_KEY = 'onLoadBanners'
